






























































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { clearEmptyAttr } from "@root/utiles/common";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";

const kaReward = namespace("kaReward");

@Component({})
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class KaRewardSummary extends Vue {
  @kaReward.Action queryKaStat: Function;
  @kaReward.Action exportKaStat: Function;
  @kaReward.Action getFlowDate;

  private dataList: any[] = [];
  gtExportDialog = false;
  exportParams: any = {};
  updateTime: any = "";

  // 搜索参数
  private form: any = {
    storeName: "",
    month: ""
  };

  async mounted() {
    Promise.all([this.getData(), this.getUpdateTime()]);
  }

  async getUpdateTime() {
    const res: any = await this.getFlowDate();
    this.updateTime = res || "";
  }

  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    try {
      const res = await this.queryKaStat({
        pageSize,
        pageNum,
        ...this.form
      });
      this.dataList = res.list || [];
      (this as any).total = res.total || 0;
      this.exportParams = { ...this.form };
    } catch (e) {
      console.log(e);
    }
  }
}
